import styled from 'styled-components'
import { easings } from '../../styles/vars/easings.style'
import { clamp } from '../../styles/utils/conversion.style'
import { breakpoints } from '../../styles/vars/breakpoints.style'
import { colors } from '../../styles/vars/colors.style'

export const CarouselNavMain = styled.div`
  display: flex;
  overflow: hidden;
  padding: 0.1rem;
  pointer-events: all;
  justify-content: ${props => props.align};
`

export const CarouselNavButton = styled.button`
  appearance: none;
  background: none;
  border: 0.1rem solid
    ${props =>
      props.color
        ? props.color.length === 4
          ? `${props.color}6`
          : `${props.color}66`
        : `${colors.darkBlue}66`};
  border-radius: 50%;
  cursor: pointer;
  ${clamp('height', 40, 50, breakpoints.mobile, breakpoints.contained)}
  margin-left: ${props =>
    props.flip
      ? 0
      : clamp(
          'margin-left',
          10,
          12,
          breakpoints.mobile,
          breakpoints.contained
        )};
  overflow: hidden;
  ${clamp('width', 40, 50, breakpoints.mobile, breakpoints.contained)}
  will-change: transform;

  svg {
    opacity: 1;
    pointer-events: none;
    transform: scale(0.99) rotateZ(${props => (props.flip ? `180deg` : `0deg`)});
    transition: transform ${easings.out.quart}, opacity ${easings.out.quart};
    transition-duration: 0.4s;
    transition-delay: 0.25s;

    &:nth-of-type(2) {
      height: 100%;
      left: 0;
      opacity: 0;
      position: absolute;
      top: 0;
      transform: scale(0.99)
        rotateZ(${props => (props.flip ? `180deg` : `0deg`)}) translateX(-80%);
      transition: transform ${easings.in.quart}, opacity ${easings.in.quart};
      transition-duration: 0.4s;
      transition-delay: 0s;
      width: 100%;
    }
  }

  &:hover {
    svg {
      opacity: 0;
      transform: scale(0.99)
        rotateZ(${props => (props.flip ? `180deg` : `0deg`)}) translateX(80%);
      transition: transform ${easings.in.quart}, opacity ${easings.in.quart};
      transition-duration: 0.4s;

      &:nth-of-type(2) {
        opacity: 1;
        transform: scale(0.99)
          rotateZ(${props => (props.flip ? `180deg` : `0deg`)}) translateX(0);
        transition: transform ${easings.out.quart}, opacity ${easings.out.quart};
        transition-duration: 0.4s;
        transition-delay: 0.25s;
      }
    }
  }
`
